import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import {
  COLLECTIONS_LOAD_COLLECTION_SNAPSHOTS_BEGIN,
  COLLECTIONS_LOAD_COLLECTION_SNAPSHOTS_SUCCESS,
  COLLECTIONS_LOAD_COLLECTION_SNAPSHOTS_FAILURE,
  COLLECTIONS_LOAD_COLLECTION_SNAPSHOTS_DISMISS_ERROR,
} from './constants';
import axios from 'axios';

export function loadCollectionSnapshots(args = {}) {
  return (dispatch) => {
    dispatch({
      type: COLLECTIONS_LOAD_COLLECTION_SNAPSHOTS_BEGIN,
    });
    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);

    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/collection-snapshots/${projectId}/project`,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: COLLECTIONS_LOAD_COLLECTION_SNAPSHOTS_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: COLLECTIONS_LOAD_COLLECTION_SNAPSHOTS_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissLoadCollectionSnapshotsError() {
  return {
    type: COLLECTIONS_LOAD_COLLECTION_SNAPSHOTS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COLLECTIONS_LOAD_COLLECTION_SNAPSHOTS_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        loadCollectionSnapshotsPending: true,
        loadCollectionSnapshotsError: null,
      };

    case COLLECTIONS_LOAD_COLLECTION_SNAPSHOTS_SUCCESS:
      // The request is success
      return {
        ...state,
        loadCollectionSnapshotsPending: false,
        loadCollectionSnapshotsError: null,
        collectionSnapshots: action.data,
      };

    case COLLECTIONS_LOAD_COLLECTION_SNAPSHOTS_FAILURE:
      // The request is failed
      return {
        ...state,
        loadCollectionSnapshotsPending: false,
        loadCollectionSnapshotsError: action.data.error,
      };

    case COLLECTIONS_LOAD_COLLECTION_SNAPSHOTS_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        loadCollectionSnapshotsError: null,
      };

    default:
      return state;
  }
}
